export default "__VITE_ASSET__DfNoc7uj__"